import React, { useMemo } from "react";
import { DataGrid } from "devextreme-react";
import { TabPanel, Item as TabPanelItem } from "devextreme-react/tab-panel";
import {
    getPropsDataGridColSpan,
    getPropsDataGrid,
    getPropsDataGridEditing,
    getPropsDataGridPopup,
} from "../../../../../utils/default-props";
import {
    Column,
    Editing,
    FormItem,
    Popup,
    RequiredRule,
} from "devextreme-react/data-grid";
import { useDataSource } from "../../../../../contexts/dataSource";
import { useAuth } from "../../../../../contexts/auth";
import { getDataGridCustomToolbar } from "../../../../../components/default-components/data-grid-custom-toolbar";

function BusinessTripDataGrid({ loadUrl, insertUrl, popupTitle, toolbarTitle, columns }) {
    const { user } = useAuth();
    const { dataSourceHR } = useDataSource();

    const dataSource = useMemo(
        () =>
            dataSourceHR({
                loadUrl,
                insertUrl,
            }),
        [user]
    );

    return (
        <DataGrid {...getPropsDataGrid} dataSource={dataSource}>
            <Editing {...getPropsDataGridEditing}>
                <Popup {...getPropsDataGridPopup} title={popupTitle} />
            </Editing>

            {getDataGridCustomToolbar(toolbarTitle)}

            {columns.map((column, index) => (
                <Column key={index} dataField={column.dataField} caption={column.caption}>
                    <FormItem {...getPropsDataGridColSpan} />
                    {column.required && <RequiredRule />}
                </Column>
            ))}
        </DataGrid>
    );
}

function BusinessTripManagement() {
    const tabs = [
        {
            title: "Seyahat Tanımları",
            loadUrl: "/api/BusinessTripPurpose",
            insertUrl: "/api/BusinessTripPurpose/FormData",
            popupTitle: "Seyahat Bilgisi",
            toolbarTitle: "Seyahat Tanımları",
            columns: [
                { dataField: "name", caption: "Seyahat Türü", required: true },
                { dataField: "description", caption: "Açıklama", required: true },
            ],
        },
        {
            title: "Seyahat Ulaşım Tanımları",
            loadUrl: "/api/BusinessTripTransportation",
            insertUrl: "/api/BusinessTripTransportation/FormData",
            popupTitle: "Seyahat Ulaşım Bilgisi",
            toolbarTitle: "Seyahat Ulaşım Tanımları",
            columns: [
                { dataField: "name", caption: "Seyahat Ulaşım Tipi", required: true },
            ],
        },
        {
            title: "Seyahat Konaklama Tanımları",
            loadUrl: "/api/BusinessTripAccommodation",
            insertUrl: "/api/BusinessTripAccommodation/FormData",
            popupTitle: "Seyahat Konaklama Bilgisi",
            toolbarTitle: "Seyahat Konaklama Tanımları",
            columns: [
                { dataField: "name", caption: "Seyahat Konaklama Tipi", required: true },
                { dataField: "description", caption: "Açıklama", required: true },
            ],
        },
        {
            title: "Seyahat Yerleri Tanımları",
            loadUrl: "/api/BusinessTripLocation",
            insertUrl: "/api/BusinessTripLocation/FormData",
            popupTitle: "Seyahat Bilgisi",
            toolbarTitle: "Seyahat Yerleri Tanımları",
            columns: [
                { dataField: "name", caption: "Seyahat Yeri", required: true },
                { dataField: "description", caption: "Açıklama", required: true },
            ],
        },
    ];

    return (
        <div className={"content-block"}>
            <div className={"dx-card responsive-paddings"}>
                <TabPanel>
                    {tabs.map((tab, index) => (
                        <TabPanelItem key={index} title={tab.title}>
                            <BusinessTripDataGrid
                                loadUrl={tab.loadUrl}
                                insertUrl={tab.insertUrl}
                                popupTitle={tab.popupTitle}
                                toolbarTitle={tab.toolbarTitle}
                                columns={tab.columns}
                            />
                        </TabPanelItem>
                    ))}
                </TabPanel>
            </div>
        </div>
    );
}

export default BusinessTripManagement;
